import Grid from '@/global/components/ui/Grid'
import { useAuth } from '@/hooks'
import { periodicidade } from '@/locales/plan'
import { CategoriaEnum } from '@acme/auth'
import { TextField } from '@mui/material'
import { FormField, FormFieldSelect } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { planos as planos_api } from 'service/api'

export default function FormPlanoDiferenciado() {
    const {
        decoded: { categoria },
    } = useAuth()
    const { data: planos } = planos_api.useFetch()

    const { watch, setValue, setError, clearErrors } = useFormContext()

    const [periodicidadeSelecionada, plano] = watch([
        'PlanoDiferenciado.periodicidade',
        'tmp_plano',
    ])

    useEffect(() => {
        const planoSelecionado = planos?.find(
            ({ limiteFuncionarios, periodicity }) =>
                limiteFuncionarios == plano &&
                periodicity === periodicidadeSelecionada,
        )
        handleChangeVariacao(Number(watch('tmp_variacao')))
        if (!planoSelecionado) return

        setValue(
            'PlanoDiferenciado.limiteFuncionarios',
            Number(planoSelecionado.limiteFuncionarios),
        )
    }, [plano, periodicidadeSelecionada])

    function handleChangeVariacao(value: number) {
        value = value || 0
        if (
            categoria !== CategoriaEnum.Administrador &&
            (value > 10 || value < -10)
        ) {
            return setError('tmp_variacao', {
                type: 'manual',
                message: 'O valor deve ser entre -10 e 10',
            })
        }

        value = Math.max(Math.min(value, Number.MAX_SAFE_INTEGER), -100)

        const planoSelecionado = planos?.find(
            ({ limiteFuncionarios, periodicity }) =>
                limiteFuncionarios == plano &&
                periodicity === periodicidadeSelecionada,
        )
        if (!planoSelecionado)
            return setValue('PlanoDiferenciado.valorCentavos', 0)

        clearErrors('tmp_variacao')
        setValue(
            'PlanoDiferenciado.valorCentavos',
            Math.round(+planoSelecionado.price * (1 + value / 100)),
        )
    }

    return [
        <Grid item xs={12} key="plano">
            <FormFieldSelect
                name="tmp_plano"
                label="Plano original"
                options={
                    planos
                        ?.filter(
                            ({ periodicity }) =>
                                periodicity === periodicidadeSelecionada,
                        )
                        .map(({ limiteFuncionarios, periodicity }) => ({
                            value: String(limiteFuncionarios),
                            label: `até ${limiteFuncionarios} funcionários (${periodicidade[periodicity]})`,
                        })) ?? []
                }
            />
        </Grid>,
        <Grid item xs={6} key="original">
            <TextField
                label="Preço original"
                InputProps={{
                    readOnly: true,
                }}
                value={new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                }).format(
                    Number(
                        +(
                            planos?.find(
                                ({ limiteFuncionarios, periodicity }) =>
                                    limiteFuncionarios == plano &&
                                    periodicity === periodicidadeSelecionada,
                            )?.price ?? 0
                        ) / 100,
                    ),
                )}
                variant="filled"
                fullWidth
            />
        </Grid>,
        <Grid item xs={6} key="variacao">
            <FormField
                name="tmp_variacao"
                label="Acréscimo/Desconto"
                type="number"
                autoComplete="off"
                onChange={e => handleChangeVariacao(Number(e.target.value))}
                min={categoria === CategoriaEnum.Administrador ? -100 : -10}
                max={categoria === CategoriaEnum.Administrador ? undefined : 10}
                InputProps={{
                    endAdornment: (
                        <div className="inline-flex items-center">
                            <span>%</span>
                            <IconeAjuda>
                                Acréscimo/Desconto medido em porcentagem em
                                relação ao valor original do plano.
                                {categoria !== CategoriaEnum.Administrador &&
                                    'Não pode superar 10%.'}
                                <br />
                                <br />
                                Exemplo:
                                <br />
                                <table
                                    style={{
                                        borderCollapse: 'separate',
                                        borderSpacing: '0.7rem 0.3rem',
                                    }}
                                >
                                    <tr>
                                        <td>Valor original</td>
                                        <td>R$ 100,00</td>
                                    </tr>
                                    <tr>
                                        <td>10% (Acréscimo)</td>
                                        <td>R$ 110,00</td>
                                    </tr>
                                    <tr>
                                        <td>-10% (Desconto)</td>
                                        <td>R$ 90,00</td>
                                    </tr>
                                </table>
                            </IconeAjuda>
                        </div>
                    ),
                }}
                disabled={!plano}
            />
        </Grid>,
    ]
}
